// Fair-game POI categories for Matching / Measuring questions. Baked from
// OpenStreetMap (scripts/bake-pois.mjs) across the NYC metro. Each category is
// a toggleable layer on every board so players can measure & compare.
//
// Most categories are points (pins). Parks are POLYGONS — rendered as shaded
// areas so players measure to the park EDGE, not a centroid.
import poiData from "../public/data/pois.json";

export interface Poi { name: string; lat: number; lng: number; }
export interface ParkPoly { name: string; geometry: GeoJSON.Polygon | GeoJSON.MultiPolygon; }
export interface PoiCategory { id: string; label: string; emoji: string; color: string; polygon?: boolean; }

export const POI_CATEGORIES: PoiCategory[] = [
  { id: "museum", label: "Museums", emoji: "🏛", color: "#8e44ad" },
  { id: "library", label: "Libraries", emoji: "📚", color: "#2980b9" },
  { id: "cinema", label: "Movie theaters", emoji: "🎬", color: "#c0392b" },
  { id: "hospital", label: "Hospitals", emoji: "🏥", color: "#e74c3c" },
  { id: "golf", label: "Golf courses", emoji: "⛳", color: "#1e8449" },
  { id: "zoo", label: "Zoos", emoji: "🦁", color: "#d35400" },
  { id: "aquarium", label: "Aquariums", emoji: "🐠", color: "#16a085" },
  { id: "amusement", label: "Amusement parks", emoji: "🎢", color: "#e67e22" },
  { id: "park", label: "Parks", emoji: "🌳", color: "#229954", polygon: true },
  { id: "consulate", label: "Consulates", emoji: "🏛", color: "#34495e" },
  { id: "mountain", label: "Mountains/peaks", emoji: "⛰", color: "#7f8c8d" },
];

const data = poiData as unknown as Record<string, unknown>;
export const POIS = data as Record<string, Poi[]>;

/** Point POIs (every non-polygon category) as one FeatureCollection. */
export function poiFC(): GeoJSON.FeatureCollection {
  const features: GeoJSON.Feature[] = [];
  for (const cat of POI_CATEGORIES) {
    if (cat.polygon) continue;
    for (const p of (data[cat.id] as Poi[]) || []) {
      features.push({
        type: "Feature",
        geometry: { type: "Point", coordinates: [p.lng, p.lat] },
        properties: { cat: cat.id, name: p.name },
      });
    }
  }
  return { type: "FeatureCollection", features };
}

/** Park polygons as a FeatureCollection (shaded areas, measured to the edge). */
export function parkFC(): GeoJSON.FeatureCollection {
  const features = ((data.park as ParkPoly[]) || []).map((p) => ({
    type: "Feature" as const,
    geometry: p.geometry,
    properties: { name: p.name },
  }));
  return { type: "FeatureCollection", features };
}
